<template>
  <div class="border border-1 product-card product-card-horizontal my-1">
    <div class="product-thumbnail">
      <m-a :href="{name:'Product', params:{name: product.raw_link}}">
        <img :src="product.thumbnail" alt="product title" class=""/>
      </m-a>
    </div>
    <div class="product-card-body text-center">
      <h2 class="product-title w-100 text-center">
        <m-a :href="{name:'Product', params:{name: product.raw_link}}">{{ product.name }}</m-a>
      </h2>
      <div class="product-variant">
        <!--        <span class="color" style="background-color: #d4d4d4;"></span>
                <span class="color" style="background-color: #e86841;"></span>
                <span class="color" style="background-color: #b82c32;"></span>-->
      </div>

      <m-product-price-100 v-if="product.price != null" :product="product"/>

    </div>
    <div class="product-card-footer">

      <m-shopping-cart-controller-1 :product="product"/>

      <!--  اضافه کردن rate به این قسمت      -->
      <!--<div class="product-rating">

                <b-icon icon="star-fill" variant="warning" class="p-0 m-0"/>
                <strong class="text-dark">۴.۴</strong>
                <span class="text-muted">(۴۳۶)</span>
              </div>-->
    </div>
  </div>
</template>

<script>

export default {
  name: "C104",
  props: ['product'],
}
</script>

<style scoped>
.product-card {
  background-color: #fff;
  border-radius: 18px;
  padding-right: 15px;
  padding-left: 15px;
  position: relative;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  height: 395px;
}

.product-card .product-thumbnail {
  padding-top: 10px;
  padding-bottom: 15px;
}

.product-card .product-thumbnail a {
  display: block;
  position: relative;
}

.product-card .product-thumbnail img {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
}

.product-card .product-title {
  color: #212121;
  font-size: 17px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-card .product-title a {
  color: inherit;
  text-decoration: none;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
}

.product-card .product-variant {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.product-card .product-variant .color {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
  margin-bottom: 2px;
}

.product-card .product-actions ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  list-style: none;
}

.product-card .product-actions ul li {
  margin-left: 10px;
}

.product-card .product-actions ul li:last-child {
  margin-left: 0;
}

.product-card .product-actions ul a {
  color: #212121;
  font-size: 20px;
  text-decoration: none;
}

.product-card .product-rating strong {
  margin-right: 3px;
}

.product-card .countdown-timer {
  direction: ltr;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-weight: 600;
  border-top: 1px solid #eee;
  padding: 10px 0;
}

.product-card .countdown-timer .divider {
  margin-right: 5px;
  margin-left: 5px;
}

.product-card.product-card-horizontal {
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.product-card.product-card-horizontal .product-thumbnail {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 100%;
  padding-bottom: 10px;
  width: 100% !important;

}

.product-card.product-card-horizontal .product-thumbnail img {
  max-width: 100%;
}

.product-card.product-card-horizontal .product-card-body {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 100%;
  padding-top: 10px;
}

.product-card.product-card-horizontal .product-card-body .product-price {
  margin-top: 20px;
}

.product-card.product-card-horizontal .product-card-footer {
  position: absolute;
  bottom: 15px;
  left: 0;
  width: 100%;
}

.product-swiper-slider .product-card {
  max-width: 270px;
  margin: auto;
}

body.loaded .product-card .product-thumbnail a::before {
  display: none;
}

.tooltip {
  direction: rtl;
  font-size: 13px;
}

a {
  text-decoration: none !important;
  color: var(--dark) !important;
}

.card-img {
  max-height: 300px !important;
  min-height: 280px !important;
  object-fit: contain;
}
</style>